






























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GZipForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    value: { type: String as PropType<string>, default: '' },
    name: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isPassword: { type: Boolean as PropType<boolean>, default: false },
    underline: { type: Boolean as PropType<boolean>, default: false },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerRules(): string {
      if (this.isRequired) {
        return 'required|numeric';
      } else {
        return 'numeric';
      }
    },
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gTextFormProvider as any).validate();
    },
  },
});
